// @flow

import React, { useRef, useEffect } from 'react';
import ClientPage from '../../context/clientPage';
import i18n from '../../../i18n';

const FormError = () => {
  const errorMsg = useRef(null);
  useEffect(() => errorMsg.current.focus(), []);

  return (
    <ClientPage.Consumer>
      {({ pageData, customNS }) => (
        <div id='wbiFormErrorMsg' className='alert alert-warning form-error' aria-live='polite'>
          <span ref={errorMsg} tabIndex='-1'>{i18n.t(pageData.errorMsg, {ns: customNS})}</span>
        </div>
      )}
    </ClientPage.Consumer>
  );
};

export default FormError;
